import  { produce } from 'immer';
import { isString, set as lSet } from 'lodash';
import { create } from 'zustand';

import type { Order } from '../../types';
import { COST_APPROVAL_FREE_DEFAULT } from '../../utils/constants';
// import { findNextWeekday } from '../../utils/date';

interface IOrderState {
  nonce?: string;
  order?: Order;
  resetOrderState: () => void;
  setNonce: (nonce: string) => void;
  setValue: (value: string | boolean | number, key: string) => void;
  setAccessories: (accessories: Order['accessories']) => void;
  setJaws: (jaws: Order['jaws']) => void;
  setService: (service: string) => void;
  setProduct: (id: string | number, name: string) => void;
  setSameReturnAddress: (isSame: boolean) => void;
  sameReturnAddress: boolean;
}

const today = new Date();

today.setDate(today.getDate() + 1);

const initialState = {
  sameReturnAddress: false,
  order: {
    // extra setter
    service: '',
    product: '',
    product_name: '',
    description: '',
    bridgingDeviceRequired: false,
    isComplaint: false,
    complaintCategory: '',
    leak_pipe_dimension: undefined,
    leak_solution: undefined,
    pipe_system_name_manufacturer: undefined,
    checkedLegal: false,
    jaws: {
      jaws_12_35_mm: 0,
      jaws_42_54_mm: 0,
      jaws_64_mm: 0
    },
    accessories: {
      charger: 0,
      case: 0,
      mains_adapter: 0,
      batteries: 0
    },
    // generic setter
    customer_number: '',
    reference_number: '',
    coupon: '',
    order_info: '',
    // pickup_date: findNextWeekday(new Date()).toLocaleDateString('de-DE'),
    pickup_date: undefined,
    number_of_parcels: 1,
    cost_approval: COST_APPROVAL_FREE_DEFAULT,
    // address setter
    deliveryAddress: undefined,
    diffDeliveryAddress: false,
    pickupAddress: undefined,
    diffPickupAddress: false,
    invoiceRecipient: undefined,
    diffInvoiceRecipient: false,
    address: undefined
  }
};

const useOrderStore = create<IOrderState>(set => ({
  ...initialState,
  resetOrderState: () => {
    set(initialState);
  },
  // setters
  setNonce: nonce =>
    set(
      produce(draft => {
        draft.nonce = nonce;
      })
    ),
  setValue: (value, key) => {
    const valuesToTrim = [ 'address.zip' ];
    const valueToUse = valuesToTrim.includes(key) && isString(value) ? value.trim() : value;

    set(
      produce(draft => {
        lSet(draft.order, key, valueToUse);

        // If pickupAddress gets changed and sameReturnAddress is active copy pickupAddress to deliveryAddress
        if (draft.sameReturnAddress && key.startsWith('pickupAddress')) {
          if (draft.order.pickupAddress) {
            draft.order.deliveryAddress = { ...draft.order.pickupAddress };
            draft.order.diffDeliveryAddress = true;
          }
        }

        // If diffDeliveryAddress is explicitly set to false, unset sameReturnAddress
        if (key === 'diffDeliveryAddress' && value === false) {
          draft.sameReturnAddress = false;
        }
      })
    );
  },
  setService: service =>
    set(
      produce(draft => {
        draft.order.service = service;
      })
    ),
  setProduct: (id: string | number, name: string) =>
    set(
      produce(draft => {
        draft.order.product = id;
        draft.order.product_name = name;
      })
    ),
  setAccessories: accessories =>
    set(
      produce(draft => {
        draft.order.accessories = accessories;
      })
    ),
  setJaws: jaws =>
    set(
      produce(draft => {
        draft.order.jaws = jaws;
      })
    ),
  setSameReturnAddress: (isSame: boolean) =>
    set(
      produce(draft => {
        draft.sameReturnAddress = isSame;

        if (isSame) {
          draft.order.diffDeliveryAddress = true;

          if (draft.order?.pickupAddress) {
            draft.order.deliveryAddress = { ...draft.order.pickupAddress };
          }
        } else if (!isSame) {
          // draft.order.deliveryAddress = undefined;
          // draft.order.diffDeliveryAddress = false;
        }
      })
    )
}));

export default useOrderStore;
